import { Injectable } from '@angular/core';
import { environment } from '@env';
import { ResourceService } from '@app/http/resource/resource.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { RecaptchaSerializer } from './recaptcha.serializer';
import { RecaptchaEvent } from './recaptcha-events';
import { Router } from '@angular/router';
import { map, take, tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class RecaptchaGeneralService extends ResourceService<RecaptchaEvent> {
  constructor(httpClient: HttpClient) {
    super(
      httpClient,
      `${environment.API}`,
      `settings/captcha`,
      new RecaptchaSerializer());
  }

  verifyCrendentials(recaptcha) {
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + localStorage.getItem('tokenPS'),
      })
    };
    return this.httpClient
      .post(`api/captcha/verify`, recaptcha, options)
      .pipe(
        take(1),
        tap((log) => {
            if(!environment.production) {
              console.log(log)
            } 
          }),
        map(data => this.serializer.fromJson(data))
      );
  }

}


